export class InvoiceCustomerInfo {
    NationalIdentityNumber: string;
    Email: string;
    FirstName: string;
    FamilyName: string; // Not mandatory for corporate users -- MT
    Country: string;
    CityName: string;
    CitySubdivisionName: string;
    Address: string;
    TaxOffice: string;
    PhoneNumber: string;
}



// WEBPACK FOOTER //
// ./src/app/models/invoice-customer-info.ts